import { render, staticRenderFns } from "./SimpleBeautifulPhone.vue?vue&type=template&id=72a987f6"
import script from "./SimpleBeautifulPhone.vue?vue&type=script&lang=js"
export * from "./SimpleBeautifulPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports